/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetAnonymousPasswordRequest
 */
export interface SetAnonymousPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SetAnonymousPasswordRequest
     */
    password?: string;
}

/**
 * Check if a given object implements the SetAnonymousPasswordRequest interface.
 */
export function instanceOfSetAnonymousPasswordRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetAnonymousPasswordRequestFromJSON(json: any): SetAnonymousPasswordRequest {
    return SetAnonymousPasswordRequestFromJSONTyped(json, false);
}

export function SetAnonymousPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetAnonymousPasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function SetAnonymousPasswordRequestToJSON(value?: SetAnonymousPasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

